import { render } from "./Asistencia.vue?vue&type=template&id=bcee3314"
import script from "./Asistencia.vue?vue&type=script&lang=js"
export * from "./Asistencia.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__